// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.hAwtoEgzQ4TxEiYyJ5pE{flex-wrap:wrap;align-items:center;gap:8px;margin:0 20px 20px;display:flex}.FpKHOy0RMYnUjLYFdDLy{justify-content:center;align-items:center;height:100%;display:flex}.oplETAWOUsysFMSIIgPI{border:1px solid var(--interaction-neutral-normal);border-radius:8px;align-items:center;height:147px;margin:0 20px 20px;display:flex}.YKRUJRCnCvEx9zUif8L1{flex-direction:column;flex:1;justify-content:center;align-items:flex-start;gap:12px;height:100%;padding:20px;display:flex}.K6wPY9qrK8ZcADjn5fm7{background:var(--interaction-neutral-normal);width:1px;height:100%}.s4WO5vyZp01OehBnIerB{flex-grow:1;margin:0 20px;display:flex;position:relative}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"filtersRow": `hAwtoEgzQ4TxEiYyJ5pE`,
	"fullPageContainer": `FpKHOy0RMYnUjLYFdDLy`,
	"kpiSection": `oplETAWOUsysFMSIIgPI`,
	"kpiItem": `YKRUJRCnCvEx9zUif8L1`,
	"kpiDivider": `K6wPY9qrK8ZcADjn5fm7`,
	"tableSection": `s4WO5vyZp01OehBnIerB`
};
export default ___CSS_LOADER_EXPORT___;
